import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import ptBRCommon from './locales/pt-BR/common.json';
import enCommon from './locales/en/common.json';

const capacitorLanguageDetector = {
  name: 'capacitorLanguageDetector',
  // O detector do browser espera 'lookup'.
  // Retornamos undefined aqui para não travar e deixar a detecção seguir para localStorage/navigator
  lookup: () => {
    return undefined;
  },
  cacheUserLanguage: (lng) => {
    if (Capacitor.isNativePlatform()) {
      Preferences.set({ key: 'language', value: lng }).catch(() => {});
    }
  }
};

const detector = new LanguageDetector();
detector.addDetector(capacitorLanguageDetector);

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { common: ptBRCommon },
      'en': { common: enCommon }
    },
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    detection: {
      // Adicionamos nosso detector na ordem, mas ele será um 'placeholder'
      order: Capacitor.isNativePlatform() ? ['capacitorLanguageDetector', 'localStorage', 'navigator'] : ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Lógica Assíncrona para Capacitor:
// Como o i18n.init é síncrono, buscamos o idioma real do dispositivo/preferências aqui
if (Capacitor.isNativePlatform()) {
  Preferences.get({ key: 'language' }).then(({ value }) => {
    if (value) {
      i18n.changeLanguage(value);
    } else {
      const deviceLang = navigator.language || navigator.userLanguage;
      const detected = deviceLang.startsWith('pt') ? 'pt-BR' : 'en';
      i18n.changeLanguage(detected);
    }
  }).catch(e => console.error("Erro ao ler idioma das Preferences", e));
}

export default i18n;
